export {FileIcon} from './FileIcon';
export type {FileIconProps, FileIconSize} from './FileIcon';
